export function cleanText(value) {
  if (value === undefined || value === null) {
    return null;
  }
  const trimmed = String(value).trim();
  return trimmed ? trimmed : null;
}

export function normaliseIdentSpacing(value) {
  if (!value) return value;
  return String(value).replace(/\s*-\s*/g, "-").replace(/\s+/g, "");
}

export function normaliseRegistration(value) {
  const cleaned = cleanText(value);
  if (!cleaned) return null;
  return normaliseIdentSpacing(cleaned).toUpperCase();
}

export function normaliseManualLocation(value) {
  const cleaned = cleanText(value);
  if (!cleaned) return null;
  return cleaned.toUpperCase();
}

export function canonicalIdent(value) {
  const cleaned = cleanText(value);
  if (!cleaned) return null;
  return cleaned.replace(/\s+/g, "").toUpperCase();
}

export function getStatusIdent(aircraft = {}) {
  const registration = cleanText(aircraft.registration);
  if (registration) {
    return normaliseIdentSpacing(registration);
  }
  const tail = cleanText(aircraft.tail);
  if (tail) {
    return normaliseIdentSpacing(tail);
  }
  const ident = cleanText(aircraft.ident);
  if (ident) {
    return normaliseIdentSpacing(ident);
  }
  const msn = cleanText(aircraft.msn);
  if (msn) {
    return normaliseIdentSpacing(msn);
  }
  return null;
}

export function getLookupKeys(aircraft = {}) {
  const keys = new Set();
  const statusIdent = getStatusIdent(aircraft);
  if (statusIdent) {
    keys.add(statusIdent.toUpperCase());
  }
  [aircraft.registration, aircraft.tail, aircraft.msn, aircraft.ident]
    .map((value) => cleanText(value))
    .filter(Boolean)
    .forEach((value) => keys.add(value.toUpperCase()));
  return Array.from(keys);
}

export function getPrimaryIdent(aircraft = {}) {
  return (
    getStatusIdent(aircraft) ||
    cleanText(aircraft.registration) ||
    cleanText(aircraft.tail) ||
    cleanText(aircraft.ident) ||
    null
  );
}
